import { render, staticRenderFns } from "./NwxAppProductsSelect.vue?vue&type=template&id=d181b770&scoped=true"
import script from "./NwxAppProductsSelect.vue?vue&type=script&lang=js"
export * from "./NwxAppProductsSelect.vue?vue&type=script&lang=js"
import style0 from "./NwxAppProductsSelect.vue?vue&type=style&index=0&id=d181b770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d181b770",
  null
  
)

export default component.exports